import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import {getResizeImagePaths, onImageError} from '../../utils';
import {Panel, PulseLoader, Avatar, Button} from '../common';

export default class TreasureRedemption extends PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        rid: PropTypes.string,
      }),
    }).isRequired,
    fetchRedemptionDetails: PropTypes.func.isRequired,
    approveRedemption: PropTypes.func.isRequired,
    rejectRedemption: PropTypes.func.isRequired,
    isRedemptionFetching: PropTypes.bool,
    isRedemptionProcessing: PropTypes.bool,
    requester: PropTypes.shape({}),
    treasure: PropTypes.shape({}),
    result: PropTypes.string,
  };

  static defaultProps = {
    isRedemptionFetching: false,
    isRedemptionProcessing: false,
    requester: null,
    treasure: null,
    result: '',
  };

  componentDidMount() {
    const {fetchRedemptionDetails, match: {params: {rid}}} = this.props;
    fetchRedemptionDetails({rid});
  }

  renderTreasureError = () => <h3>Could not load Treasure</h3>;

  renderTreasure = ({points, name, description = '', image}) => {
    const {defaultImageURL, resizedImageURL} = getResizeImagePaths(image, 100);

    return (
      <Fragment>
        <h3>Requested Treasure Item</h3>
        <div className="row  row_gap_m row_space-between">
          <div className="cell cell_auto">
            <figure className="treasure">
              <div
                className="redemption__image_wrap row row_vcenter row_center"
              >
                <img
                  className="treasure__image"
                  src={resizedImageURL}
                  onError={onImageError(defaultImageURL)}
                  alt={name}
                  title={name}
                />
              </div>
              <figcaption className="treasure__name">{name}</figcaption>
              <div className="treasure__points">
                YakGold:&nbsp;
                <b>{points}</b>
              </div>
            </figure>
          </div>
          <div className="cell cell_auto">
            <div className="delimeter delimeter_vertical"/>
          </div>
          <div className="cell">
            <div className="row redemption__label">Description:</div>
            <div className="row redemption__description">{description}</div>
          </div>
        </div>
      </Fragment>
    );
  };

  renderRequesterError = () => <h3>Could not load Treasure Redeemer</h3>;

  renderRequester = ({firstName, lastName, image}) => (
    <Fragment>
      <h3>User Information</h3>
      <div className="row row_gap_m">
        <div className="cell cell_auto redemption__image_wrap row row_vcenter row_center">
          <Avatar
            image={image}
            imageWidth={180}
            fullName={`${firstName} ${lastName}`}
            iconSize="72"
            className="redemption__avatar"
          />
        </div>
        <div className="cell cell_auto">
          <div className="delimeter delimeter_vertical"/>
        </div>
        <div className="cell">
          <div className="row redemption__label">First Name:</div>
          <div className="row redemption__value">{firstName}</div>
          <div className="row redemption__label">Last Name:</div>
          <div className="row redemption__value">{lastName}</div>
        </div>
      </div>
    </Fragment>
  );

  renderRedemption = () => {
    const {
      treasure,
      requester,
      approveRedemption,
      rejectRedemption,
      isRedemptionProcessing,
      match: {params: {rid}},
    } = this.props;

    return (
      <div className="cell">
        {treasure ? this.renderTreasure(treasure) : this.renderTreasureError()}
        {requester ? this.renderRequester(requester) : this.renderRequesterError()}
        {treasure && requester &&
        <div className="row row_center">
          <Button
            size="xl"
            text="Decline"
            handler={() => rejectRedemption({rid})}
            disabled={isRedemptionProcessing}
          />
          <Button
            size="xl"
            text="Accept"
            handler={() => approveRedemption({rid})}
            disabled={isRedemptionProcessing}
          />
        </div>
        }
      </div>
    );
  };

  renderNoResult = fetching => (fetching ? <PulseLoader/> : this.renderRedemption());

  render() {
    const {isRedemptionFetching, result} = this.props;
    return (
      <Panel
        title="Point Redemption Request"
        size="m"
      >
        <div className="redemption row row_center">
          {result ? <h3>{result}</h3> : this.renderNoResult(isRedemptionFetching)}
        </div>
      </Panel>
    );
  }
}
